<div *ngIf="apiLoaded">
    <google-map
        #gMap
        height="100%"
        width="100%"
        [center]="center"
        [zoom]="zoom"
        [options]="mapOptions"
        [mapId]="mapId"
    >
    </google-map>
</div>

<ng-template #spotPin let-spot="spot">
    <div class="spot-pin">
        <ng-container *ngTemplateOutlet="pinShadow"></ng-container>
        <div class="spot-img-frame">
            <img [src]="spot.locationImgUrl" class="spot-pin-img" alt=""/>
        </div>
        <span class="spot-caption">{{ spot?.pinCaption || spot.name }}</span>
    </div>
</ng-template>

<ng-template #pinShadow>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%"
         height="100%"
         viewBox="1 -3 70 76" fill="none" x="0px" y="0px">
        <g filter="url(#filter0_d_1839_1899)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M41.6752 64.514C57.1281 62.0211 68.9298 48.6212 68.9298 32.4649C68.9298 14.535 54.3948 0 36.4649 0C18.535 0 4 14.535 4 32.4649C4 48.3882 15.4637 61.6339 30.5882 64.3993C30.6216 64.4623 30.6587 64.5245 30.6997 64.5858L34.5027 70.2642C35.2948 71.447 37.034 71.447 37.8262 70.2642L41.6291 64.5858C41.6451 64.562 41.6604 64.5381 41.6752 64.514Z"
                  fill="#424242"/>
        </g>
        <defs>
            <filter id="filter0_d_1839_1899" x="0" y="0" width="72.9297" height="79.1513" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                               result="hardAlpha"/>
                <feOffset dy="4"/>
                <feGaussianBlur stdDeviation="2"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1839_1899"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1839_1899" result="shape"/>
            </filter>
        </defs>
    </svg>
</ng-template>

<app-spot-detail-modal [spot]="selectSpot" [modalConfig]="spotDetailModalConfig"></app-spot-detail-modal>
